'use client';

import { useEffect, useState } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import AuthDialog from './AuthDialog';

export default function AuthDialogHandler() {
  const [showAuthDialog, setShowAuthDialog] = useState(false);
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    // Check if we're on the register path and have a referral code
    const isRegisterPath = pathname === '/register';
    const hasReferralCode = searchParams.has('ref');

    if (isRegisterPath || hasReferralCode) {
      setShowAuthDialog(true);
    }
  }, [pathname, searchParams]);

  return (
    <AuthDialog
      open={showAuthDialog}
      onClose={() => setShowAuthDialog(false)}
      initialMode="login"
    />
  );
}